export default __webpack_public_path__ + "static/media/screen3.031c95c6.png";